import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, doc, setDoc, getDoc, getDocs, deleteDoc } from 'firebase/firestore';
import './AbaSelos.css';

function AbaSelos() {
  const [novoSeloId, setNovoSeloId] = useState("");
  const [novoSeloNome, setNovoSeloNome] = useState("");
  const [novoSeloMotivo, setNovoSeloMotivo] = useState("");
  const [novoSeloImagem, setNovoSeloImagem] = useState("");
  const [mensagem, setMensagem] = useState(null);
  const [selosExistentes, setSelosExistentes] = useState([]);
  const [uidParaAtribuir, setUidParaAtribuir] = useState("");
  const [seloParaAtribuir, setSeloParaAtribuir] = useState("");
  const [mensagemAtribuir, setMensagemAtribuir] = useState(null);

  async function atribuirSelo() {
    if (!uidParaAtribuir || !seloParaAtribuir) {
      setMensagemAtribuir("Preenche o UID e escolhe um selo.");
      return;
    }

    try {
      const seloSelecionado = selosExistentes.find(s => s.id === seloParaAtribuir);
      if (!seloSelecionado) {
        setMensagemAtribuir("Selo não encontrado.");
        return;
      }

      const userRef = doc(db, "usuarios", uidParaAtribuir);
      const docSnap = await getDoc(userRef);

      if (!docSnap.exists()) {
        setMensagemAtribuir("Usuário não encontrado.");
        return;
      }

      const dadosAtuais = docSnap.data();
      const selosAtuais = Array.isArray(dadosAtuais.selosGanhos) ? dadosAtuais.selosGanhos : [];

      const novosSelos = selosAtuais.includes(seloParaAtribuir)
        ? selosAtuais
        : [...selosAtuais, seloParaAtribuir];

      await setDoc(userRef, {
        selooficial: seloParaAtribuir,
        selosGanhos: novosSelos
      }, { merge: true });

      setMensagemAtribuir("✅ Selo atribuído com sucesso!");
      setUidParaAtribuir("");
      setSeloParaAtribuir("");
    } catch (erro) {
      console.error("Erro ao atribuir selo:", erro);
      setMensagemAtribuir("❌ Ocorreu um erro ao atribuir o selo.");
    }
  }

  function carregarSeloParaEdicao(selo) {
    setNovoSeloId(selo.id);
    setNovoSeloNome(selo.nome);
    setNovoSeloMotivo(selo.motivo);
    setNovoSeloImagem(selo.imagemUrl || "");
    setMensagem("Edita os campos acima e clica em 'Salvar selo' para atualizar.");
  }

  async function excluirSelo(selo) {
    const confirmacao = window.confirm(`Queres mesmo excluir o selo "${selo.nome}"?`);
    if (!confirmacao) return;

    try {
      await deleteDoc(doc(db, "selos", selo.id));
      setSelosExistentes((prev) => prev.filter((s) => s.id !== selo.id));
      setMensagem(`✅ Selo "${selo.nome}" excluído com sucesso.`);
    } catch (erro) {
      console.error("Erro ao excluir selo:", erro);
      setMensagem("❌ Erro ao excluir o selo.");
    }
  }

  useEffect(() => {
    async function carregarSelos() {
      try {
        const snap = await getDocs(collection(db, "selos"));
        const lista = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setSelosExistentes(lista);
      } catch (erro) {
        console.error("Erro ao carregar selos:", erro);
      }
    }

    carregarSelos();
  }, []);

  async function handleUploadSelo() {
    if (!novoSeloId || !novoSeloNome || !novoSeloMotivo || !novoSeloImagem) {
      setMensagem("Preenche todos os campos.");
      return;
    }

    try {
      await setDoc(doc(db, "selos", novoSeloId), {
        nome: novoSeloNome,
        motivo: novoSeloMotivo,
        imagemUrl: novoSeloImagem,
        criadoEm: new Date().toISOString()
      });

      setMensagem("✅ Selo criado com sucesso!");
      setNovoSeloId("");
      setNovoSeloNome("");
      setNovoSeloMotivo("");
      setNovoSeloImagem("");
    } catch (erro) {
      console.error("Erro ao salvar selo:", erro);
      setMensagem("❌ Ocorreu um erro ao salvar o selo.");
    }
  }

  return (
    <div className="admin-bloco-upload-selo">
      <h2>Criar novo selo</h2>
      <form className="admin-selos-form" onSubmit={(e) => { e.preventDefault(); handleUploadSelo(); }}>
        <label>
          ID do selo (sem espaços)
          <span>ex: estreia-oficial</span>
          <input type="text" value={novoSeloId} onChange={(e) => setNovoSeloId(e.target.value)} required />
        </label>

        <label>
          Nome do selo
          <span>ex: Estreia Oficial</span>
          <input type="text" value={novoSeloNome} onChange={(e) => setNovoSeloNome(e.target.value)} required />
        </label>

        <label>
          Motivo (descrição curta)
          <span>ex: Por fazer a primeira aposta!</span>
          <input type="text" value={novoSeloMotivo} onChange={(e) => setNovoSeloMotivo(e.target.value)} required />
        </label>

        <label>
          URL da imagem do selo (PNG):
          <span>ex: https://i.imgur.com/abc123.png</span>
          <input type="text" value={novoSeloImagem} onChange={(e) => setNovoSeloImagem(e.target.value)} required />
        </label>

        <button type="submit" className="admin-botao-salvar-selo">Salvar selo</button>
      </form>

      {mensagem && <p className="mensagem">{mensagem}</p>}

      <h2>Selos existentes</h2>

      {selosExistentes.length === 0 && <p className="mensagem">Ainda não há nenhum selo criado.</p>}

      <div className="lista-selos-admin">
        {selosExistentes.map((selo) => (
          <div key={selo.id} className="selo-admin-item">
            <img src={selo.imagemUrl} alt={selo.nome} />
            <div>
              <strong>{selo.nome}</strong>
              <p>ID: {selo.id}</p>
              <p>{selo.motivo}</p>
              <div className="botoes-selo-admin">
                <button onClick={() => carregarSeloParaEdicao(selo)}>Editar</button>
                <button onClick={() => excluirSelo(selo)}>Excluir</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="admin-bloco-atribuir-selo">
        <h2>Atribuir selo a utilizador</h2>
        <form className="admin-selos-form" onSubmit={(e) => { e.preventDefault(); atribuirSelo(); }}>
          <label>
            UID do utilizador
            <span>Encontra na raiz do Firestore em "usuarios"</span>
            <input type="text" value={uidParaAtribuir} onChange={(e) => setUidParaAtribuir(e.target.value)} required />
          </label>

          <label>
            Escolhe o selo
            <select value={seloParaAtribuir} onChange={(e) => setSeloParaAtribuir(e.target.value)} required>
              <option value="">-- Seleciona --</option>
              {selosExistentes.map((selo) => (
                <option key={selo.id} value={selo.id}>
                  {selo.nome}
                </option>
              ))}
            </select>
          </label>

          <button type="submit" className="admin-botao-salvar-selo">Atribuir selo</button>
        </form>

        {mensagemAtribuir && <p className="mensagem">{mensagemAtribuir}</p>}
      </div>
    </div>
  );
}

export default AbaSelos;